import { Link, useLocation, useNavigate } from 'react-router-dom'
import styles from './styles.module.css'
import { useEffect } from 'react'
import PrimaryButton from '../../global/components/buttons/primary-button/PrimaryButton'
import SecondaryButton from '../../global/components/buttons/secondary-button/SecondaryButton'
import {
  QUALITY_CONTROL_NAMES,
  QUALITY_CONTROL_PATHS,
} from '../../global/constants/quality-control'

const lastQualityControlPathKey = 'lastQualityControlPath'
const BASE_PATH = '/quality-control'
const PATHS = {
  CASES_TABLE: {
    NAME: QUALITY_CONTROL_NAMES.casesTable,
    PATH: QUALITY_CONTROL_PATHS.casesTable,
  },
  REWORKS: {
    NAME: QUALITY_CONTROL_NAMES.reworks,
    PATH: QUALITY_CONTROL_PATHS.reworks,
  },
  DEFECTS: {
    NAME: QUALITY_CONTROL_NAMES.defects,
    PATH: QUALITY_CONTROL_PATHS.defects,
  },
  CARPET_CHART: {
    NAME: QUALITY_CONTROL_NAMES.carpetChart,
    PATH: QUALITY_CONTROL_PATHS.carpetChart,
  },
}
const DEFAULT_PATH = PATHS.CASES_TABLE.PATH

function TabChooser() {
  const navigate = useNavigate()

  const links = [
    {
      name: PATHS.CASES_TABLE.NAME,
      path: PATHS.CASES_TABLE.PATH,
    },
    {
      name: PATHS.REWORKS.NAME,
      path: PATHS.REWORKS.PATH,
    },
    {
      name: PATHS.DEFECTS.NAME,
      path: PATHS.DEFECTS.PATH,
    },
    {
      name: PATHS.CARPET_CHART.NAME,
      path: PATHS.CARPET_CHART.PATH,
    },
  ]

  const activePath = useLocation().pathname

  const noActivePath = activePath === BASE_PATH

  useEffect(() => {
    if (noActivePath) {
      const lastPath = localStorage.getItem(lastQualityControlPathKey)

      navigate(lastPath || DEFAULT_PATH)
    } else {
      const pathToSave =
        links.find((link) => link.path === activePath)?.path || DEFAULT_PATH

      localStorage.setItem(lastQualityControlPathKey, pathToSave)
    }
  }, [noActivePath, navigate])

  return (
    <div className={styles.buttonsHolder}>
      {links.map((link, idx) =>
        activePath.startsWith(link.path) ? (
          <Link
            className={styles.link}
            to={link.path}
            key={idx}
          >
            <PrimaryButton
              buttonName={link.name}
              onClick={() => {}}
              style={{ width: 'max-content', height: 'max-content' }}
            />
          </Link>
        ) : (
          <Link
            className={styles.link}
            to={link.path}
            key={idx}
          >
            <SecondaryButton
              buttonName={link.name}
              onClick={() => {}}
              style={{ width: 'max-content', height: 'max-content' }}
            />
          </Link>
        ),
      )}
    </div>
  )
}

export default TabChooser
